<template>
	<div class='story'>
		<Header />
		<div class='scrolly'>
			<figure>
				<Kaart :data="gemeenteData" />
			</figure>

			<article class='knd-steps'>
				<div
					v-for='(step, index) in stepper' :key='"step" + index'  
					class='step' 
					:class="{'step__quote': step.quote}" 
					:data-key='step.key'
					:data-zoom='step.zoom'
					:data-highlight='step.highlight'
					>
					<div class='step-inner' :class="{'step-search': step.key === 'SEARCH'}">
						<div v-if="step.quote">
								<div class='knd-step__image gradient-overlay' v-if="step.afbeelding" >
									<picture >
										<source media="(max-width: 799px)" 
										:srcset="processWireBase + step.afbeelding[0].mobile_url">
										<source media="(min-width: 800px)" 
										:srcset="processWireBase + step.afbeelding[0].url">
										<img :srcset="processWireBase + step.afbeelding[0].url" alt="" loading="lazy">
									</picture>
								</div>
								<div class='step__quote_inner'>
									<div v-html="step.content"></div>
								</div>
							</div>

							<div v-else-if="step.key === 'SEARCH'">
									<div class='knd-gemeente-input knd-input-field m-b-sm m-t-sm'>
									<p>
										Nu ben je vast benieuwd hoe dit in jouw eigen gemeente zit. Vul die hieronder in.
									</p>
									<div class='knd-search knd-search__gemeente m-t-md'>
										<input id="gemeenteinput" placeholder="Zoek op gemeente" />
									</div>

									<div class='dropdown-input knd-search knd-search__buurt m-t-md' v-show="showBuurten">
										<input ref="buurten" id="buurteninput" placeholder="Zoek op wijk" />
										<button ref="buurtenbutton" class="dropdown-btn" type="button"><span class="caret"></span></button>
									</div>

									<div class='knd-buurt-info m-t-md'>
											<BuurtInfo /> 
									</div>
								</div>
							</div>

							<div v-else>
								<div v-html="step.content"></div>
							</div>
					</div>
				</div>
			</article>
		</div>

		<div class='knd-contrain knd-colofon m-t-lg'>
				<div v-html="$store.state.data.colofon"></div>
		</div>
	</div>
</template>

<script>
	import scrollama from "scrollama";
	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';

	import Kaart from './kaart';
	import Header from './header';
	import BuurtInfo from './buurtinfo';

export default {
	name: 'App',
	components: {
		Kaart, Header,BuurtInfo
	},
	data: function() {
		return {
			gemeenteData: this.$store.state.gemeenteData,
			stepper: this.$store.state.data.stepper,
			showBuurten: false,
			showBuurtInfo: false,
			gemeenteCode: undefined
		}
	},

	mounted: function() {
		this.stackedBarScroller = scrollama();

		let input = this.$refs.buurten;
		let buurtenbutton = this.$refs.buurtenbutton;
		let _self = this;

		this.buurtenPlete = new Awesomplete(input, {
			minChars: 0,
			maxItems: 100,
			replace: (suggestion) => {
				input.value = suggestion.label;
				this.showBuurtInfo = true;
				_self.$store.dispatch('onSetBuurt', suggestion.value);
				// let data = _self.$store.getters.getBuurtData(_self.gemeenteCode, suggestion.value);
			}
		});

		buurtenbutton.addEventListener("click", ()  => {
			if (this.buurtenPlete.ul.childNodes.length === 0) {
				this.buurtenPlete.minChars = 0;
				this.buurtenPlete.evaluate();
			}
			else if (this.buurtenPlete.ul.hasAttribute('hidden')) {
				this.buurtenPlete.open();
			}
			else {
				this.buurtenPlete.close();
			}
		});


		this.renderAutoComplete();

		this.setupScroller();
	},
	computed: {
			buurten() {
				return this.$store.getters.buurten;
			},
			gmCode() {
				return this.$store.getters.gmCode;
			}			
		},
		watch: {
			buurten(newValue, oldValue) {
				if(newValue && newValue !== oldValue) {
					this.showBuurten = true;
					this.$refs.buurten.value = '';

					this.$nextTick(() => {
						this.renderDetailAutocomplete(newValue);
					})

				}
			},
			gmCode(newValue, oldValue) {
				if(newValue && newValue !== oldValue) {
					this.renderDetailAutocomplete(this.buurten);
				}
		}
	},

	methods: {
		setupScroller() {
			var midpoint = Math.floor(window.innerHeight * 0.8) + "px";

			this.steps = document.querySelectorAll(".scrolly .step");
			
			this.stackedBarScroller
			.setup({
				container: ".scrolly",
				graphic: ".scrolly figure",
				text: ".scrolly article",
				step: this.steps,
				offset: midpoint,
				debug: false
			})
			.onStepEnter(this.handleStepEnter)
			.onStepExit(this.handleStepExit);

		},

		renderDetailAutocomplete(detail) {
			let items = detail.map(d => {
				return {label: d.WK_NAAM, value: d.WK_CODE}
			});

			this.buurtenPlete.list = items;

			this.$refs.buurten.focus();
		},

		renderAutoComplete() {
			let gemeentes = this.gemeenteData.objects.gemeente.geometries.map(d => {
				return {label: d.properties.GM_NAAM, value: d.properties.GM_CODE}
			});

			this.inputGemeente = document.getElementById("gemeenteinput");

			new Awesomplete(this.inputGemeente, {
				list: gemeentes,
				replace: (suggestion) => {
					this.inputGemeente.value = suggestion.label;

					this.$store.dispatch('onSearch', suggestion.value);
					this.showBuurtInfo = false;
					this.gemeenteCode = suggestion.value;

				}
			});
		},

		handleStepEnter(response) {
			// response = { element, direction, index }

			this.$store.dispatch('updateStep', {index: response.index, ...response.element.dataset});

			if(response.element.dataset.key === 'SEARCH' && this.$store.state.firstSearch) {
				this.$store.dispatch('loadBuurtData');
			}

			for (let i =0; i < this.steps.length; i++) {
				if(i === response.index) {
					this.steps[i].classList.add('is-active');
				} else  {
					this.steps[i].classList.remove('is-active');
				}

			}
		},

		handleStepExit(response) {
			response.element.classList.remove('is-active');
		}
	}
}
</script>